export const WINDOWS_MT5_DOWNLOAD_LINK =
  'https://download.mql5.com/cdn/web/inno.net.solutions/mt5/innonetsolutions5setup.exe'
export const ANDROID_MT5_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en'
export const APPLE_MT5_DOWNLOAD_LINK = 'https://apps.apple.com/kw/app/metatrader-5/id413251709'
